var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 231,
    viewBox: "0 0 154 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.708 40.5659H6.76734C6.42553 40.5659 6.14844 40.8396 6.14844 41.1773V228.919C6.14844 229.257 6.42553 229.531 6.76734 229.531H152.708C153.05 229.531 153.327 229.257 153.327 228.919V41.1773C153.327 40.8396 153.05 40.5659 152.708 40.5659Z",
    fill: "#5B80FF",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.233 35.6484H1.29176C0.949945 35.6484 0.672852 35.9222 0.672852 36.2598V224.002C0.672852 224.339 0.949945 224.613 1.29176 224.613H147.233C147.574 224.613 147.851 224.339 147.851 224.002V36.2598C147.851 35.9222 147.574 35.6484 147.233 35.6484Z",
    fill: "white",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7471 92.8911H126.822",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7021 94.313L28.6581 102.633L51.8671 83.1489",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7471 120.801H126.822",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7021 122.236L28.6581 130.543L51.8671 111.059",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7471 148.711H126.822",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7021 150.146L28.6581 158.453L51.8671 138.969",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7471 176.634H126.822",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7021 178.056L28.6581 186.376L51.8671 166.879",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.949 20.8162H84.3189V10.3698C84.3189 5.2131 80.0538 1 74.8335 1H73.7168C68.4964 1 64.2314 5.2131 64.2314 10.3698V20.8029H44.6013C39.0715 20.8029 34.5508 25.2685 34.5508 30.7309V44.5398C34.5508 44.8454 34.8064 45.0847 35.1024 45.0847H113.448C113.757 45.0847 114 44.8322 114 44.5398V30.7309C114 25.2685 109.479 20.8029 103.949 20.8029V20.8162Z",
    fill: "#57E79B",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.f2005bb530dcd8dd71b63089f955ef83.svg";
export { ForwardRef as ReactComponent };